/**
 * Explicaciones de cómo cada integración apoya al emprendedor.
 * Exportado en archivo separado para evitar tree-shaking por Webpack.
 */
export const EXPLICACIONES: Record<string, { titulo: string; beneficios: string[] }> = {
  whatsapp: {
    titulo: '📱 WhatsApp',
    beneficios: [
      '✅ Responde automáticamente a tus clientes en WhatsApp',
      '✅ Sin pagar operadores 24/7',
      '✅ Atiende 100 conversaciones simultáneamente',
      '✅ Tus clientes ya usan WhatsApp, no necesitan app nueva',
    ],
  },
  instagram: {
    titulo: '📸 Instagram',
    beneficios: [
      '✅ Contesta mensajes directos de Instagram automáticamente',
      '✅ Aumenta respuesta a leads desde redes sociales',
      '✅ El agente entiende el contexto de tus publicaciones',
      '✅ Captura clientes que te contactan por DM sin esperar',
    ],
  },
  messenger: {
    titulo: '💬 Messenger (Facebook)',
    beneficios: [
      '✅ Atiende mensajes de tu página de Facebook',
      '✅ Los clientes no esperen horas por respuesta',
      '✅ Integra comentarios en publicaciones',
      '✅ Aumenta tasa de conversión de leads',
    ],
  },
  google_calendar: {
    titulo: '📅 Google Calendar',
    beneficios: [
      '✅ Clientes agenden citas sin contactarte',
      '✅ El agente ve tu calendario en vivo',
      '✅ No se reservan horas que ya están ocupadas',
      '✅ Ahorra 30+ min/día coordinando citas',
    ],
  },
  google_sheets: {
    titulo: '📊 Google Sheets',
    beneficios: [
      '✅ Leads se guardan automáticamente en tu planilla',
      '✅ Sin copiar/pegar datos manualmente',
      '✅ Tu equipo accede a leads en tiempo real',
      '✅ Integra con CRM o herramientas de análisis',
    ],
  },
  gmail: {
    titulo: '✉️ Gmail',
    beneficios: [
      '✅ El agente envía confirmaciones por correo',
      '✅ Notificaciones automáticas sin costo',
      '✅ Tus clientes reciben info en email (su canal preferido)',
      '✅ Mejora profesionalismo de tu negocio',
    ],
  },
  mercadolibre: {
    titulo: '🛍️ Mercado Libre',
    beneficios: [
      '✅ Responde preguntas de compradores en vivo',
      '✅ El agente ve stock y precios actualizados',
      '✅ Aumenta conversión: respuestas rápidas = más ventas',
      '✅ Reduce devoluciones por mala información',
    ],
  },
  woocommerce: {
    titulo: '🏪 WooCommerce',
    beneficios: [
      '✅ El agente conoce tu tienda online al instante',
      '✅ Responde sobre productos, envíos, cambios',
      '✅ Reduce tickets de soporte en 60%',
      '✅ Aumenta ticket promedio (recomendaciones del agente)',
    ],
  },
  slack: {
    titulo: '🚀 Slack',
    beneficios: [
      '✅ Recibe notificaciones de leads en tu canal privado',
      '✅ Tu equipo coordina respuesta en tiempo real',
      '✅ No te pierdes ningún cliente importante',
      '✅ Escalación rápida a humano si es necesario',
    ],
  },
  zapier: {
    titulo: '⚡ Zapier',
    beneficios: [
      '✅ Conecta con 5.000+ apps (CRM, email, herramientas)',
      '✅ Automatiza workflows sin código',
      '✅ El agente dispara acciones en tus herramientas favoritas',
      '✅ Integración infinita: lo que imaginas, se automatiza',
    ],
  },
  n8n: {
    titulo: '🔄 n8n',
    beneficios: [
      '✅ Automatiza procesos complejos en tu negocio',
      '✅ El agente ejecuta workflows personalizados',
      '✅ Integra múltiples servicios (facturas, inventario, etc)',
      '✅ Solución de código abierto = datos tuyos',
    ],
  },
};

// Force webpack to include this module
export const forceInclude = () => Object.keys(EXPLICACIONES).length > 0;
